import { render, staticRenderFns } from "./BackEnd.vue?vue&type=template&id=71038a72"
import script from "./BackEnd.vue?vue&type=script&lang=js"
export * from "./BackEnd.vue?vue&type=script&lang=js"
import style0 from "./BackEnd.vue?vue&type=style&index=0&id=71038a72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports